<input [placeholder]="placeholder"
    class=" rounded-lg flex-1 appearance-none border w-full pl-4 pr-9 py-2 border-gray-300  bg-white dark:bg-dark text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent"
    (keyup)="InputEvent($event)">